import { Component, OnInit, OnDestroy, ViewChild, ComponentFactoryResolver, Inject, ViewContainerRef, ComponentRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { BaseComponent } from '../models/components/BaseComponent';
import { AdvancedPropertyComponent } from './advanced-property-component.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalData } from './modal-data.model';

@Component({
  selector: 'app-advanced-property-window',
  templateUrl: './advanced-property-window.component.html',
  styleUrls: ['./advanced-property-window.component.css']
})
export class AdvancedPropertyWindowComponent implements OnInit, OnDestroy {
  // property which maps the component key to the corosponding component
  // property which holds a advanced-property-component value
  viewComponent: any;
  // Array of Components defining a Object
  components: Array<BaseComponent>;
  additionalData: any;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  title: string = 'Advanced Properties';
  action1: string = 'Cancel';
  action2: string = 'Save';

  @ViewChild('target', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef;
  componentRef: ComponentRef<any>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    public dialogRef: MatDialogRef<AdvancedPropertyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData) {
    if (data.components !== null && data.components !== undefined) {
      this.components = data.components;
      this.viewComponent = data.viewComponent;
      this.additionalData = data.additionalData;
    }
  }

  ngOnInit() {
    this.loadComponent();
  }

  loadComponent() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.viewComponent);
    const viewContainerRef = this.vcRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(componentFactory);
    (<AdvancedPropertyComponent>this.componentRef.instance).items = this.components;
    (<AdvancedPropertyComponent>this.componentRef.instance).additionalData = this.additionalData;
    (<AdvancedPropertyComponent>this.componentRef.instance).setBaseDimensions();
  }

  saveButtonDisabledState(): boolean {
    let result = (<AdvancedPropertyComponent>this.componentRef.instance).saveButtonDisabledState();
    return result;
  }

  save() {
    let updatedComponents = (<AdvancedPropertyComponent>this.componentRef.instance).items;
    if (updatedComponents === undefined || updatedComponents === null) {
      this.dialogRef.close();
    }
    else {
      this.dialogRef.close(updatedComponents);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
